import { ReminderPriorityFeedQuery } from './reminder_priority_feed_query';
import { ReminderQuery } from './reminder_query';
import { ReminderListQuery } from './reminder_list_query';

angular
  .module('data-ng-personal-reminders')
  .service('ngReminderPriorityFeedQuery', ReminderPriorityFeedQuery)
  .service('ngReminderQuery', ReminderQuery)
  .service('ngReminderListQuery', ReminderListQuery);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/queries/reminder_queries_module.ts